/**
 * Returns a fallback value if the input is empty/null/undefined
 * @param value Input string value that may be empty/null/undefined
 * @param fallback Optional fallback value, defaults to '-' if not provided
 * @returns Original value if present, fallback value if empty
 */
export const emptyValueFallback = (value?: string | null | undefined, fallback: string = '-') => value || fallback;

/**
 * Checks if the current index is the last item in a list
 * @param index Current index being checked
 * @param length Total length of the list
 * @returns True if index is the last item, false otherwise
 */
export const isLastItemReached = (index: number, length: number) => index === length - 1 && index >= 0;
